import { Title, Wrapper } from "./NotFound.styled";

const NotFound = () => (
  <Wrapper>
    <Title>NOT FOUND</Title>
  </Wrapper>
);

export default NotFound;
